import { Component, OnInit } from '@angular/core';
import { FlowPayThirdParty } from '../../../../enum/landing-enum';

@Component({
  selector: 'flowaccount-flowpay-third-party-payment',
  templateUrl: './flowpay-third-party-payment.component.html',
  styleUrls: ['./flowpay-third-party-payment.component.scss']
})
export class FlowpayThirdPartyPaymentComponent implements OnInit {
  thirdPartyChannel = 1
  creditCardLogo: { visa: string; mastercard: string; JCB: string; promptpay: string; };

  flowpayThirdPartyEnum = FlowPayThirdParty

  ngOnInit(): void {
    this.creditCardLogo = {
      visa: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/visa-logo.png" width="auto" height="20" alt="visa-logo">',
      mastercard: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/master-card-logo.png" width="auto" height="20" alt="visa-logo">',
      JCB: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/jcb-logo.png" width="auto" height="20" alt="visa-logo">',
      promptpay: '<img class="mt-minus-5" src="https://flowaccountcdn.com/images/payment/Promptpay.png" width="auto" height="20" alt="visa-logo">'
    }
  }

  onClickTab(no: number) {
    return this.thirdPartyChannel = no
  }

  loopArray(no: number) {
    return new Array(no)
  }

}
